import { useState, useEffect, useCallback } from 'react'
import { Outlet } from 'react-router-dom'
import BottomNav from './BottomNav'
import DevBanner from './DevBanner'
import SaveIndicator from './SaveIndicator'
import { get } from '../services/api'
import { useAuth } from '../context/AuthContext'
import { useRealtimeEvents, EventType } from '../context/RealtimeContext'

function Layout() {
  const { partner } = useAuth()
  const [taskBadgeCount, setTaskBadgeCount] = useState(0)

  // Fetch task counts for badge
  const fetchTaskCounts = useCallback(async () => {
    if (!partner?.id) return

    try {
      // Fetch my open tasks and unclaimed tasks in parallel
      const [myResponse, poolResponse] = await Promise.all([
        get('/tasks', { owner: partner.id }),
        get('/tasks', { status: 'pool' }),
      ])

      // My open tasks (not completed)
      const myOpenCount = (myResponse.tasks || []).filter(t => t.status !== 'completed').length
      // Unclaimed tasks
      const unclaimedCount = (poolResponse.tasks || []).length

      setTaskBadgeCount(myOpenCount + unclaimedCount)
    } catch (err) {
      console.error('Failed to fetch task counts:', err)
    }
  }, [partner?.id])

  // Initial fetch
  useEffect(() => {
    fetchTaskCounts()
  }, [fetchTaskCounts])

  // Refresh on task events
  const handleTaskEvent = useCallback(() => {
    fetchTaskCounts()
  }, [fetchTaskCounts])

  useRealtimeEvents(
    [
      EventType.TASK_CREATED,
      EventType.TASK_CLAIMED,
      EventType.TASK_UNCLAIMED,
      EventType.TASK_COMPLETED,
    ],
    handleTaskEvent
  )

  return (
    <div className="flex flex-col h-full bg-crm-bg max-w-md mx-auto">
      {/* Dev mode banner */}
      {__DEV_MODE__ && <DevBanner />}

      {/* Header with Save Indicator */}
      <header className="flex items-center justify-between px-4 py-2 bg-crm-bg-light border-b border-crm-bg-lighter safe-area-top">
        <h1 className="text-lg font-semibold text-crm-gold">CRM Poker</h1>
        <SaveIndicator />
      </header>

      {/* Main content area */}
      <main className="flex-1 overflow-y-auto hide-scrollbar pb-20">
        <Outlet />
      </main>

      {/* Bottom navigation */}
      <BottomNav taskBadgeCount={taskBadgeCount} />
    </div>
  )
}

export default Layout
